import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SocialLogin = ({ isLoading, onSocialLogin }) => {
  const socialProviders = [
    {
      name: 'Google',
      icon: 'Chrome',
      color: '#4285F4',
      bgColor: 'bg-blue-50 hover:bg-blue-100'
    },
    {
      name: 'Facebook',
      icon: 'Facebook',
      color: '#1877F2',
      bgColor: 'bg-blue-50 hover:bg-blue-100'
    }
  ];

  const handleSocialLogin = (provider) => {
    if (onSocialLogin) {
      onSocialLogin(provider);
    }
  };

  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-card text-muted-foreground">
            Or continue with
          </span>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {socialProviders?.map((provider) => (
          <Button
            key={provider?.name}
            variant="outline"
            onClick={() => handleSocialLogin(provider?.name?.toLowerCase())}
            disabled={isLoading}
            className="flex items-center justify-center space-x-2 py-3"
          >
            <Icon 
              name={provider?.icon} 
              size={18} 
              color={provider?.color}
            />
            <span className="text-sm font-medium">{provider?.name}</span>
          </Button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground text-center">
        By continuing, you agree to our{' '}
        <button className="text-primary hover:text-primary/80 transition-gentle">
          Terms of Service
        </button>{' '}
        and{' '}
        <button className="text-primary hover:text-primary/80 transition-gentle">
          Privacy Policy
        </button>
      </p>
    </div>
  );
};

export default SocialLogin;